/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissions: string[] = currentUser?.permissions ?? [];
  const hasWildcardPermission = permissions.includes('*');
  const hasPermission = (code: string) =>
    hasWildcardPermission || permissions.includes(code);
  const canAdmin = currentUser?.access === 'admin';
  const canUseExternalInteractionAction = (permission: string) =>
    canAdmin || hasPermission('*') || hasPermission(permission);
  return {
    canAdmin,
    canSystemUser: hasPermission('system:user:view'),
    canSystemUserEdit: hasPermission('system:user:edit'),
    canSystemUserRoleAssignment:
      hasPermission('system:user-role-assignment:view') ||
      hasPermission('system:user-role-assignment:edit'),
    canSystemRole: hasPermission('system:role:view'),
    canSystemRoleEdit: hasPermission('system:role:edit'),
    canSystemMenu: hasPermission('system:menu:view'),
    canSystemMenuEdit: hasPermission('system:menu:edit'),
    canSystemDept: hasPermission('system:dept:view'),
    canSystemDeptEdit: hasPermission('system:dept:edit'),
    canSystemOrg: hasPermission('system:org:view'),
    canSystemOrgEdit: hasPermission('system:org:edit'),
    canSystemCode: hasPermission('system:code:view'),
    canSystemCodeEdit: hasPermission('system:code:edit'),
    canSystemPrintTemplate: hasPermission('system:print-template:view'),
    canSystemPrintTemplateEdit: hasPermission('system:print-template:edit'),
    canSystemEmailTemplate: hasPermission('system:email-template:view'),
    canSystemEmailTemplateEdit: hasPermission('system:email-template:edit'),
    canSystemGlobalParam: hasPermission('system:global-param:view'),
    canSystemGlobalParamEdit: hasPermission('system:global-param:edit'),
    canSystemOperationLog: hasPermission('system:operation-log:view'),
    canSystemLoginLog: hasPermission('system:login-log:view'),
    canExternalInteractionLog:
      canAdmin || hasPermission('system.external_interaction_log'),
    canModelMonitor: canAdmin || hasPermission('system.model_monitor'),
    // 后端仍会做独立危险操作权限和管理员校验；前端只做导航层收口。
    canExternalInteractionRetry: canUseExternalInteractionAction(
      'system:external-interaction-log:retry',
    ),
    canExternalInteractionCancel: canUseExternalInteractionAction(
      'system:external-interaction-log:cancel',
    ),
    canExternalInteractionDelete: canUseExternalInteractionAction(
      'system:external-interaction-log:delete',
    ),
    // 独立虚拟权限节点控制组织内全员数据范围；普通打卡菜单只授予 SELF。
    canAttendancePunchViewAll:
      canAdmin || hasPermission('general:attendance:punch:view-all'),
    canSystemDataPermission: hasPermission('system:data-permission:edit'),
    canSystemFunctionPermission: hasPermission(
      'system:function-permission:edit',
    ),
    canSystemNodePermission: hasPermission('system:node-permission:edit'),
  };
}
